export default __webpack_public_path__ + "705880b66080fe3282d7555c6f7f3ad0.svg";